var yt = {
  pn: function pn() {
    return "serviceWorker" in navigator && "undefined" != typeof ServiceWorkerRegistration && "showNotification" in ServiceWorkerRegistration.prototype && "PushManager" in window;
  },
  yn: function yn() {
    return "safari" in window && "pushNotification" in window.safari && "function" == typeof window.safari.pushNotification.permission && "function" == typeof window.safari.pushNotification.requestPermission;
  },
  isPushSupported: function isPushSupported() {
    return yt.pn() || yt.yn();
  },
  isPushBlocked: function isPushBlocked() {
    var o = yt.isPushSupported() && "Notification" in window && null != window.Notification && null != window.Notification.permission && "denied" === window.Notification.permission,
      i = yt.isPushSupported() && (!("Notification" in window) || null == window.Notification);
    return o || i;
  },
  isPushPermissionGranted: function isPushPermissionGranted() {
    return yt.isPushSupported() && "Notification" in window && null != window.Notification && null != window.Notification.permission && "granted" === window.Notification.permission;
  },
  Qi: function Qi() {
    return yt.isPushBlocked() ? {
      Ui: !1,
      reason: "blocked"
    } : yt.isPushSupported() ? yt.isPushPermissionGranted() ? {
      Ui: !1,
      reason: "permissionGranted"
    } : {
      Ui: !0
    } : {
      Ui: !1,
      reason: "unsupported"
    };
  },
  Vi: function Vi(o, i) {
    return "blocked" === o ? "".concat(i, " containing a push prompt is not being shown because the user has already declined push permission prompt.") : "unsupported" === o ? "".concat(i, " containing a push prompt is not being shown because the browser doesn't support push notifications.") : "".concat(i, " containing a push prompt is not being shown because the user has already accepted the permission prompt.");
  }
};
export default yt;